import { Mui } from "@osu/react-ui";
import { NavLink } from "react-router-dom";

const IconLinkCell = (props = {}) => {
  const { Icon, to, ...rest } = props;
  return (
    <Mui.IconButton sx={{
      minHeight: '44px',
      minWidth: '44px',
    }} size="small" component={NavLink} to={to} {...rest}>
      <Icon />
    </Mui.IconButton>
  );
};

export default IconLinkCell;
